(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rsti-article-share"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-article-share]').forEach(group => {
      if (group.dataset.ready) return;
      group.dataset.ready = 'true';
      const copy = group.querySelector('[data-article-copy]');
      const share = group.querySelector('[data-article-share-native]');
      const status = group.querySelector('[role="status"]');
      const fallback = group.querySelector('[data-share-fallback]');
      const url = group.dataset.shareUrl;
      copy.hidden = false;
      share.hidden = typeof navigator.share !== 'function';
      copy.addEventListener('click', async () => {
        status.textContent = '';
        try {
          if (!navigator.clipboard?.writeText) throw new Error();
          await navigator.clipboard.writeText(url);
          fallback.hidden = true;
          status.textContent = group.dataset.copied;
        } catch {
          fallback.hidden = false;
          const input = fallback.querySelector('input'); input.focus(); input.select();
        }
      });
      share.addEventListener('click', async () => {
        if (share.dataset.busy) return;
        share.dataset.busy = 'true'; status.textContent = '';
        try { await navigator.share({ title: group.dataset.shareTitle, url }); }
        catch (error) { if (error.name !== 'AbortError') status.textContent = group.dataset.shareError; }
        finally { delete share.dataset.busy; }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rsti-article-viewer"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-rsti-article-photos]').forEach(article => {
      if (article.dataset.viewerReady) return;
      const dialog = document.getElementById(article.dataset.rstiArticlePhotos);
      if (!dialog || typeof dialog.showModal !== 'function') return;
      article.dataset.viewerReady = 'true';
      const images = [...article.querySelectorAll('figure img')].filter(img => !img.closest('a,button'));
      if (!images.length) return;
      const display = dialog.querySelector('[data-photo-image]');
      const caption = dialog.querySelector('[data-photo-caption]');
      const position = dialog.querySelector('[data-photo-position]');
      const previous = dialog.querySelector('[data-photo-previous]');
      const next = dialog.querySelector('[data-photo-next]');
      let index = 0, opener;
      function show(value) {
        index = (value + images.length) % images.length;
        const source = images[index];
        display.src = source.src; display.alt = source.alt;
        const credit = source.closest('figure').querySelector('figcaption');
        caption.replaceChildren(...(credit ? [...credit.childNodes].map(node => node.cloneNode(true)) : [document.createTextNode(source.alt)]));
        position.textContent = dialog.dataset.countLabel.replace('[current]', index + 1).replace('[total]', images.length);
        previous.hidden = next.hidden = images.length < 2;
      }
      images.forEach((img, imageIndex) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'rsti-photo-open';
        button.setAttribute('aria-label', dialog.dataset.openLabel.replace('[name]', img.alt || String(imageIndex + 1)));
        button.setAttribute('aria-haspopup', 'dialog'); button.setAttribute('aria-controls', dialog.id);
        img.before(button); button.append(img);
        const icon = document.createElement('span'); icon.className = 'rsti-photo-open__icon'; icon.setAttribute('aria-hidden','true');
        icon.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><circle cx="10" cy="10" r="6"/><path d="m15 15 6 6M7 10h6m-3-3v6"/></svg>';
        button.append(icon);
        button.addEventListener('click', () => { opener = button; show(imageIndex); dialog.showModal(); document.body.classList.add('rsti-photo-locked'); });
      });
      previous.addEventListener('click', () => show(index - 1)); next.addEventListener('click', () => show(index + 1));
      dialog.querySelector('[data-photo-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); show(index - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); show(index + 1); }
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      dialog.addEventListener('close', () => { document.body.classList.remove('rsti-photo-locked'); opener?.focus({ preventScroll: true }); });
      let start;
      display.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') start = { x:event.clientX, y:event.clientY }; });
      display.addEventListener('pointerup', event => { if (start && Math.abs(event.clientX-start.x)>60 && Math.abs(event.clientY-start.y)<50) show(index + (event.clientX<start.x?1:-1)); start = null; });
      display.addEventListener('pointercancel', () => { start = null; });
      article.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => { if (dialog.open) dialog.close(); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rsti-interactions"] && !Shopify.designMode) return;
  try {
    (() => {
  const stringsNode = document.querySelector('[data-rsti-interaction-strings]');
  if (!stringsNode) return;
  const text = JSON.parse(stringsNode.textContent);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const cleanPath = value => value.replace(/\/+$/, '') || '/';
  const format = (message, values) => Object.entries(values).reduce((result, [key, value]) => result.replace(`[${key}]`, value), message);
  const ready = (node, key) => { if (node.dataset[key]) return false; node.dataset[key] = 'true'; return true; };

  function navigation(root) {
    const path = cleanPath(window.location.pathname);
    root.querySelectorAll('.rsti-desktop-nav a, .rsti-mobile-menu nav a').forEach(link => {
      const url = new URL(link.href, location.href);
      if (url.origin !== location.origin) return;
      const target = cleanPath(url.pathname);
      const shopRoot = target.endsWith('/collections/all') ? target.slice(0, -16) : null;
      const shopSection = shopRoot !== null && ['product', 'collection', 'cart'].some(part => path === `${shopRoot}/${part === 'cart' ? part : part + 's'}` || path.startsWith(`${shopRoot}/${part}s/`));
      if (path === target) link.setAttribute('aria-current', 'page');
      else if ((target !== '/' && path.startsWith(target + '/')) || shopSection) link.setAttribute('aria-current', 'true');
    });
    root.querySelectorAll('.rsti-mobile-menu').forEach(menu => {
      if (!ready(menu, 'rstiMenuReady')) return;
      menu.addEventListener('keydown', event => {
        if (event.key === 'Escape' && menu.open) { menu.open = false; menu.querySelector('summary').focus(); }
      });
    });
  }

  // Use the existing media IDs. A unique descriptive alt match opts a list item in;
  // missing or ambiguous matches remain ordinary content, including future products.
  function galleries(root) {
    root.querySelectorAll('product-info').forEach(product => {
      const description = product.querySelector('.product__description');
      const gallery = product.querySelector('media-gallery');
      if (!description || !gallery || !ready(description, 'rstiGalleryReady')) return;
      customElements.whenDefined('media-gallery').then(() => {
        if (!description.isConnected || typeof gallery.setActiveMedia !== 'function') return;
        const normal = value => value.toLocaleLowerCase().replace(/[“”"'‘’]/g, '').replace(/\b(?:free|decal|design)\b/g, '').replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
        const media = [...gallery.querySelectorAll('[data-target]')].map(node => ({ node, name: normal(node.querySelector('img')?.alt || '') })).filter(item => item.name);
        const choices = [];
        const candidates = [...description.querySelectorAll('li')].filter(node => !node.querySelector('a,button,ul,ol'));
        description.querySelectorAll('.shop-bonus').forEach(bonus => {
          const tail = [...bonus.childNodes].filter(node => node.nodeType === Node.TEXT_NODE && node.textContent.trim()).pop();
          if (tail) { const label = document.createElement('span'); tail.replaceWith(label); label.textContent = tail.textContent; candidates.push(label); }
        });
        candidates.forEach(item => {
          const label = item.textContent.trim();
          const key = normal(label);
          if (key.length < 10) return;
          const matches = media.filter(entry => entry.name === key || entry.name.startsWith(key + ' '));
          if (matches.length !== 1) return;
          const match = matches[0];
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'rsti-gallery-choice'; button.textContent = label;
          button.setAttribute('aria-label', format(text.viewPhoto, { name: label }));
          button.setAttribute('aria-controls', gallery.id);
          button.setAttribute('aria-pressed', 'false');
          item.replaceChildren(button);
          choices.push({ button, match });
          button.addEventListener('click', () => {
            gallery.setActiveMedia(match.node.dataset.target, false);
            sync();
            status.textContent = format(text.photoSelected, { name: label });
            const active = gallery.querySelector('.product__media-item.is-active img');
            if (active && !reduceMotion.matches) active.animate([{ opacity: .88 }, { opacity: 1 }], { duration: 160 });
          });
        });
        if (!choices.length) return;
        const hint = document.createElement('p'); hint.className = 'rsti-gallery-hint'; hint.textContent = text.galleryHint;
        const firstList = choices[0].button.closest('ul, ol'); (firstList || choices[0].button.parentElement).before(hint);
        const status = document.createElement('span'); status.className = 'visually-hidden'; status.setAttribute('role', 'status'); description.append(status);
        function sync() { choices.forEach(({button, match}) => button.setAttribute('aria-pressed', String(match.node.querySelector('button')?.getAttribute('aria-current') === 'true'))); }
        const observer = new MutationObserver(sync);
        observer.observe(gallery, { subtree: true, attributes: true, attributeFilter: ['aria-current'] });
        product.addEventListener('shopify:section:unload', () => observer.disconnect(), { once: true });
        sync();
      });
    });
  }

  function forms(root) {
    root.querySelectorAll('.rsti-contact__form, form[data-rsti-submission], .rsti-subscriber-form').forEach(form => {
      if (!ready(form, 'rstiFeedbackReady')) return;
      const topic = form.querySelector('[name="contact[topic]"]');
      if (topic) {
        const updateTopic = () => {
          const key = topic.selectedOptions[0]?.dataset.rstiTopic || 'general';
          const help = form.querySelector('[data-rsti-topic-help]');
          if (help) help.textContent = text['topic' + key.charAt(0).toUpperCase() + key.slice(1)];
          const order = form.querySelector('[data-rsti-order-field]');
          if (order) order.hidden = key !== 'order';
          const build = form.querySelector('[data-rsti-build-link]');
          if (build) build.hidden = key !== 'build';
        };
        topic.addEventListener('change', updateTopic); updateTopic();
      }
      const story = form.querySelector('#BuildStory');
      if (story) {
        const update = () => { form.querySelector('[data-rsti-story-count]').textContent = format(text.storyCount, { count: story.value.length, max: story.maxLength }); };
        story.addEventListener('input', update); update();
      }
      const photos = form.querySelector('#BuildPhotos');
      if (photos) {
        const validate = () => {
          const lines = photos.value.split(/\r?\n/).map((value, index) => ({ value: value.trim(), line: index + 1 })).filter(item => item.value);
          const invalid = lines.find(item => { try { return !['http:', 'https:'].includes(new URL(item.value).protocol); } catch { return true; } });
          const error = !lines.length ? text.photoEmpty : lines.length > 5 ? text.photoMany : invalid ? format(text.photoInvalid, { line: invalid.line }) : '';
          photos.setCustomValidity(error);
          const count = form.querySelector('[data-rsti-photo-count]');
          count.textContent = error && photos.value.trim() ? error : format(text.photoCount, { count: lines.length });
          count.classList.toggle('rsti-field-error', Boolean(error && photos.value.trim()));
        };
        photos.addEventListener('input', validate); validate();
      }
      // Native constraint validation and Shopify server errors remain authoritative.
      form.querySelectorAll('input:not([type="hidden"]), textarea, select').forEach(field => {
        if (!field.id) return;
        let error;
        field.addEventListener('invalid', () => {
          field.setAttribute('aria-invalid', 'true');
          if (!error) {
            error = document.createElement('p'); error.className = 'rsti-field-error'; error.id = field.id + '-feedback';
            const parent = field.closest('.field, .rsti-contact__field, .consent') || field.parentElement;
            if (field.closest('.field, .rsti-contact__field, .consent')) parent.append(error); else parent.after(error);
            field.setAttribute('aria-describedby', [field.getAttribute('aria-describedby'), error.id].filter(Boolean).join(' '));
          }
          error.textContent = field.validationMessage;
        });
        field.addEventListener('input', () => { if (field.validity.valid) { field.removeAttribute('aria-invalid'); if (error) error.textContent = ''; } });
      });
      const button = form.querySelector('button[type="submit"]');
      if (!button) return;
      const progress = document.createElement('p'); progress.className = 'rsti-form-progress'; progress.setAttribute('role', 'status'); button.parentElement === form ? button.after(progress) : button.parentElement.after(progress);
      let timer;
      function reset() { clearTimeout(timer); button.removeAttribute('aria-busy'); progress.textContent = ''; }
      form.addEventListener('submit', event => {
        // Wait for Shopify's CAPTCHA handlers; do not disable or hijack the submit.
        queueMicrotask(() => {
          if (event.defaultPrevented) return;
          button.setAttribute('aria-busy', 'true'); progress.textContent = text.sending;
          timer = window.setTimeout(reset, 15000);
        });
      });
      form.addEventListener('input', reset); window.addEventListener('pageshow', reset);
    });
    root.querySelectorAll('.rsti-contact__intro a[href^="mailto:"]').forEach(link => {
      if (!navigator.clipboard?.writeText || !ready(link, 'rstiCopyReady')) return;
      const button = document.createElement('button'); button.type = 'button'; button.className = 'rsti-copy-email'; button.textContent = text.copyEmail;
      const status = document.createElement('span'); status.className = 'rsti-copy-status'; status.setAttribute('role', 'status');
      link.parentElement.after(button, status);
      button.addEventListener('click', async () => {
        try { await navigator.clipboard.writeText(decodeURIComponent(link.getAttribute('href').slice(7).split('?')[0])); status.textContent = ' ' + text.copied; }
        catch { status.textContent = ' ' + text.copyFailed; }
      });
    });
  }

  function highlightSignup() {
    const target = document.getElementById('rsti-subscriber-signup');
    if (!target) return;
    target.classList.add('rsti-signup-highlight');
    target.setAttribute('tabindex', '-1'); target.focus({ preventScroll: true });
    target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
    clearTimeout(target.rstiHighlightTimer);
    target.rstiHighlightTimer = window.setTimeout(() => target.classList.remove('rsti-signup-highlight'), 2200);
  }
  document.addEventListener('click', event => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.hash === '#rsti-subscriber-signup' && document.getElementById('rsti-subscriber-signup')) {
      event.preventDefault(); history.replaceState(null, '', url.hash); highlightSignup();
    }
    const menu = document.querySelector('.rsti-mobile-menu[open]');
    if (menu && !menu.contains(event.target)) menu.open = false;
  });
  document.addEventListener('pointerdown', event => { document.querySelectorAll('.rsti-mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }); });
  const initialize = (root = document) => { navigation(root); galleries(root); forms(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (location.hash === '#rsti-subscriber-signup') highlightSignup();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rsti-shop-feature"] && !Shopify.designMode) return;
  try {
    (() => {
  const featureNodes = document.querySelectorAll('[data-shop-feature]');
  if (!featureNodes.length) return;
  if (window.Shopify?.loadFeatures && !window.Shopify.customerPrivacy) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], () => {});
  }
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-shop-feature-link]');
    const feature = link?.closest('[data-shop-feature]');
    if (!feature || window.Shopify?.designMode) return;
    if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()) return;
    if (typeof window.Shopify?.analytics?.publish !== 'function') return;
    try {
      const result = window.Shopify.analytics.publish('rsti:shop_feature_clicked', {
        placement: feature.dataset.shopFeature,
        collection: feature.dataset.featureCollection,
        link_type: link.dataset.shopFeatureLink,
        product_id: link.dataset.productId || null,
        position: Number(link.dataset.featurePosition) || null,
        source_path: window.location.pathname
      });
      if (result?.catch) result.catch(() => {});
    } catch {}
  });
})();
  } catch(e) { console.error(e); }
})();

})();
